"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMoney = exports.filterPoints = exports.formatNumberValue = exports.prepareRawStackedChartData = exports.sortDates = exports.formatValue = exports.dateFormatter = exports.intlDateFormatter = exports.periodQuarter = void 0;
var highcharts_1 = __importDefault(require("highcharts"));
exports.periodQuarter = /period=quarter/.test(window.location.search);
exports.intlDateFormatter = Intl.DateTimeFormat('cs-CZ', {
    month: exports.periodQuarter || /period=year/.test(window.location.search) ? undefined : 'long',
    year: 'numeric',
});
var dateFormatter = function (date) { return exports.intlDateFormatter.format(date); };
exports.dateFormatter = dateFormatter;
var formatValue = function (value) {
    if (value >= 1000000) {
        return Math.floor(value / 10000) / 100 + " M";
    }
    if (value >= 1000) {
        return Math.floor(value / 1000) + " K";
    }
    return String(value);
};
exports.formatValue = formatValue;
var sortDates = function (dates) {
    return Object.keys(dates).sort(function (a, b) {
        return Number(new Date(a)) - Number(new Date(b));
    });
};
exports.sortDates = sortDates;
var prepareRawStackedChartData = function (data) {
    var dates = data.chartFlatPoints.reduce(function (result, point) {
        result[point.date] = {};
        return result;
    }, {});
    var byDate = data.chartFlatPoints.reduce(function (result, point) {
        if (!result[point.date]) {
            result[point.date] = {};
        }
        result[point.date][point.name] = point.value;
        return result;
    }, {});
    var byName = Object.keys(byDate).reduce(function (result, date) {
        var sum = Object.values(byDate[date]).reduce(function (actualSum, value) {
            return actualSum + Math.abs(Number(value));
        }, 0);
        Object.keys(byDate[date]).forEach(function (name) {
            if (!result[name]) {
                result[name] = {
                    name: name,
                    values: Object.assign({}, dates),
                };
            }
            result[name].values[date] = {
                value: byDate[date][name],
                percentage: (100 / sum) * byDate[date][name],
            };
        });
        return result;
    }, {});
    var reducedDates = data.chartFlatPoints.reduce(function (result, point) {
        result[point.date] = {};
        return result;
    }, {});
    return {
        data: Object.values(byName),
        dates: reducedDates,
        sortedDates: (0, exports.sortDates)(dates),
    };
};
exports.prepareRawStackedChartData = prepareRawStackedChartData;
var formatNumberValue = function (value) {
    if (value > 1000000) {
        return highcharts_1.default.numberFormat(value / 1000000, 0) + " M";
    }
    else if (value > 1000) {
        return highcharts_1.default.numberFormat(value / 1000, 0) + " K";
    }
    else {
        return "" + highcharts_1.default.numberFormat(value, 0, ',', ' ');
    }
};
exports.formatNumberValue = formatNumberValue;
var filterPoints = function (rangeData, range) {
    return rangeData.points.filter(function (point) {
        var month = new Date(point.month);
        return month.getTime() >= range.start.getTime() && month.getTime() <= range.end.getTime();
    });
};
exports.filterPoints = filterPoints;
var formatMoney = function (amount, decimalCount, suffix) {
    if (decimalCount === void 0) { decimalCount = 2; }
    if (suffix === void 0) { suffix = '\u00A0Kč'; }
    var parts = amount.toFixed(decimalCount).split('.');
    var decimalPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    return decimalPart + (parts[1] !== undefined ? "," + parts[1] : '') + suffix;
};
exports.formatMoney = formatMoney;
